module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "监控列表",
      "name": "monito"
    }
  }, [_c('monito-list')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "来源列表",
      "name": "source"
    }
  }, [_c('source-list')], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-218022fb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-218022fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/statistics/sourcemanagement/index.vue
// module id = 2531
// module chunks = 0